import { render } from "./PatientReportResult.vue?vue&type=template&id=b1e088ac"
import script from "./PatientReportResult.vue?vue&type=script&lang=js"
export * from "./PatientReportResult.vue?vue&type=script&lang=js"

import "./PatientReportResult.vue?vue&type=style&index=0&id=b1e088ac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__